import { hydrateRoot } from '@direct-frontend/modules-render/client';
import { getRequestContext } from '#shared/lib/context';
import { initClient, Router } from '../lib/clientHelpers';
import { onReactRecoverableError } from '../lib/onReactRecoverableError';
import { Application, ApplicationSuspended } from './Application';

const rootElement = document.querySelector('#app') || document.documentElement;

initClient();

hydrateRoot(
    rootElement,
    <Router>{getRequestContext().isSsrEnabled ? <Application /> : <ApplicationSuspended />}</Router>,
    { onRecoverableError: onReactRecoverableError }
);
